var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between mb-3 p-2 bg-light border rounded",
        },
        [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary me-2",
                attrs: { disabled: _vm.page <= 1 },
                on: { click: _vm.prevPage },
              },
              [_vm._v("«")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.inputPage,
                  expression: "inputPage",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control d-inline-block mx-2",
              staticStyle: { width: "70px" },
              attrs: { type: "number", min: 1, max: _vm.numPages },
              domProps: { value: _vm.inputPage },
              on: {
                change: _vm.goToPage,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.inputPage = _vm._n($event.target.value)
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c("span", [_vm._v("/ " + _vm._s(_vm.numPages || "?"))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary ms-2",
                attrs: { disabled: _vm.page >= _vm.numPages },
                on: { click: _vm.nextPage },
              },
              [_vm._v("»")]
            ),
          ]),
          _vm._v(" "),
          !_vm.pdf_ready && _vm.pdf_loading_progress < 100
            ? _c("div", { staticStyle: { "min-width": "200px" } }, [
                _c(
                  "div",
                  { staticClass: "progress", staticStyle: { height: "20px" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "progress-bar progress-bar-striped progress-bar-animated",
                        style: { width: _vm.pdf_loading_progress + "%" },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": _vm.pdf_loading_progress,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.pdf_loading_progress) +
                            "%\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.pdf_error
        ? _c("div", { staticClass: "text-center" }, [
            _c("strong", [_vm._v("ERROR")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("VuePdfEmbed", {
        ref: "pdfEmbed",
        attrs: { source: _vm.path, page: _vm.page },
        on: {
          rendered: _vm.rendered,
          progress: _vm.progress,
          "rendering-failed": _vm.rendering_failed,
          loaded: _vm.onLoaded,
        },
      }),
      _vm._v(" "),
      _vm.pdf_ready
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between mt-3 p-2 bg-light border rounded",
            },
            [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary me-2",
                    attrs: { disabled: _vm.page <= 1 },
                    on: { click: _vm.prevPage },
                  },
                  [_vm._v("«")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.inputPage,
                      expression: "inputPage",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "form-control d-inline-block mx-2",
                  staticStyle: { width: "70px" },
                  attrs: { type: "number", min: 1, max: _vm.numPages },
                  domProps: { value: _vm.inputPage },
                  on: {
                    change: _vm.goToPage,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.inputPage = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("/ " + _vm._s(_vm.numPages || "?"))]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary ms-2",
                    attrs: { disabled: _vm.page >= _vm.numPages },
                    on: { click: _vm.nextPage },
                  },
                  [_vm._v("»")]
                ),
              ]),
              _vm._v(" "),
              !_vm.pdf_ready && _vm.pdf_loading_progress < 100
                ? _c("div", { staticStyle: { "min-width": "200px" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "progress",
                        staticStyle: { height: "20px" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "progress-bar progress-bar-striped progress-bar-animated",
                            style: { width: _vm.pdf_loading_progress + "%" },
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": _vm.pdf_loading_progress,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100",
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.pdf_loading_progress) +
                                "%\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }